import { NavList } from "../shared";

const UserManagerAppList = ({ auth }: Record<string, any>) => {
    const systemAdminAppUrl = auth.superAdmin ? "/user-list" : "";
    const userManagerAppList = [
        {
            url: `${systemAdminAppUrl}/basic-login`,
            name: "Basic Login",
        },
        {
            url: `${systemAdminAppUrl}/site-admin`,
            name: "Site Admin",
        },
        {
            url: `${systemAdminAppUrl}/user-manager`,
            name: "User Manager",
        },
        {
            url: `${systemAdminAppUrl}/system-admin`,
            name: "System Admin",
        },
    ];

    const backurl = auth?.superAdmin ? "/" : undefined;

    return (
        <main className="container">
            <NavList
                backUrl={backurl}
                title="User Manager Application List"
                navList={userManagerAppList}
            />
        </main>
    );
};

export default UserManagerAppList;
